// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3M4Oa","errorLogs":"EditorFooter_errorLogs__2saTR"};